import { BreadcrumbJsonLd, NextSeo, NextSeoProps } from 'next-seo'

import { getBaseUrl } from '@/lib/contentful/utils'

import { getSeoLocale } from '@/utils/locales/getSeoLocale'
import { getLocalizedFromEnglish } from '@/utils/locales/localized-routes/getLocalizedFromEnglish'
import { generateSeoUrl } from '@/utils/seo/generateSeoUrl'
import { useUrl } from '@/utils/url/useUrl'

type Props = {
	children: React.ReactNode
	locale: string
	languageAlternates: NextSeoProps['languageAlternates']
}

export function CompanyLeadersMeta({ children, locale, languageAlternates }: Props) {
	const url = useUrl({ locale })
	const baseUrl = `${url?.protocol}//${url?.host}`

	return (
		<>
			<NextSeo
				canonical={generateSeoUrl(
					`${baseUrl}${getLocalizedFromEnglish(locale as Locale, `/company/leaders/`)}`
				)}
				languageAlternates={[
					...(languageAlternates ?? []),
					{
						hrefLang: 'x-default',
						href: `${getBaseUrl()}/company/leaders/`
					}
				]}
				openGraph={{
					url: generateSeoUrl(
						`${baseUrl}${getLocalizedFromEnglish(locale as Locale, `/company/leaders/`)}`
					),
					siteName: 'BigCommerce',
					locale: getSeoLocale(locale)
				}}
			/>
			<BreadcrumbJsonLd
				itemListElements={[
					{
						position: 1,
						name: 'Homepage',
						item: `${getBaseUrl(locale)}/`
					},
					{
						position: 2,
						name: `${getBaseUrl(locale)}${getLocalizedFromEnglish(locale as Locale, '/company/')}`,
						item: 'About Us'
					},
					{
						position: 3,
						name: `${getBaseUrl(locale)}${getLocalizedFromEnglish(
							locale as Locale,
							'/company/leaders/'
						)}`,
						item: 'Leaders'
					}
				]}
			/>
			{children}
		</>
	)
}
